import { render, staticRenderFns } from "./protocolCompanyZiZhiFiles.vue?vue&type=template&id=0b518cdb&scoped=true&"
import script from "./protocolCompanyZiZhiFiles.vue?vue&type=script&lang=js&"
export * from "./protocolCompanyZiZhiFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b518cdb",
  null
  
)

export default component.exports